import React from 'react';
import {withRouter} from "react-router-dom";
import MultipleChoicesGrid from "../common/MultipleChoicesGrid";

const MultipleChoiceGrid = (props) => {
  return <MultipleChoicesGrid {...props} />
}

export default withRouter(MultipleChoiceGrid);
